import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LoadingContainer } from "go-core/components/Loading";
import { useAuth } from "../../../services/Security/auth";
import { selectIsAuthenticated } from "../../../services/session/selectors";
import { selectUser } from "../../../services/users/selectors";
import RegisterForm from "../components/RegisterForm/RegisterForm";
import RegisterLayout from "../components/RegisterLayout";

const SecurityRegisterPage = () => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(true);
	const auth = useAuth();
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const user = useSelector(selectUser);

	if (isAuthenticated && loading) {
		setLoading(false);
	}

	const init = async () => {
		if (!isAuthenticated) {
			await auth.checkLogin();
			setLoading(false);
		}
	};

	useEffect(() => {
		init();
	}, []);

	if (loading) {
		return <LoadingContainer />;
	}

	return (
		<RegisterLayout>
			<div className="form-login-header">
				{isAuthenticated ? (
					<>
						<span className="ms-auto">
							{t("modules.security.field.logged_as.title")}
							<Link to="/profile">{user?.name ? user.name : user?.email}</Link>{" "}
						</span>
						<a className="btn btn-primary-light" href="#" onClick={() => auth.logout(true)}>
							{t("lib:common.action.logout")}
						</a>
					</>
				) : (
					<>
						<span className="ms-auto">{t("modules.security.field.already_registered.title")}</span>
						<Link to="/login" className="btn btn-primary-light">
							&nbsp;{t("modules.security.action.login.title")}
						</Link>
					</>
				)}
			</div>
			<RegisterForm />
			<p className="login-contact-link">
				{t("modules.security.field.have_question.title")}
				<a href="https://www.gopos.pl/contact">{t("modules.security.field.contact_with_sales.title")}</a>
			</p>
		</RegisterLayout>
	);
};
export default SecurityRegisterPage;
